import { HttpErrorResponse } from '@angular/common/http';
import {Component, ElementRef, Input, OnDestroy, Type, ViewChild} from '@angular/core';
import {FileItem, NxFileUploader, NxFileUploaderComponent} from '@aposin/ng-aquila/file-uploader';
import {Subscription} from 'rxjs';
import {GenericFieldDirective} from '../../directives/generic-field/generic-field.directive';
import {UploadFileStatus} from '../../enums/upload-file-status';
import {FormFileUpload} from '../../interfaces/forms/file-upload';
import {FieldService} from '../../services/field/field.service';
import {UploadService} from '../../services/upload/upload.service';
import {UploadDeleteComponent} from './components/upload-delete/upload-delete.component';
import {UploadNameComponent} from './components/upload-name/upload-name.component';
import {UploadSizeComponent} from './components/upload-size/upload-size.component';
import {UploadStatusComponent} from './components/upload-status/upload-status.component';

@Component({
    selector: 'app-upload-file-form',
    templateUrl: './upload-file-form.component.html',
    styleUrls: ['./upload-file-form.component.scss'],
    standalone: false
})
export class UploadFileFormComponent extends GenericFieldDirective implements OnDestroy {
  @Input() override field!: FormFileUpload;

  @ViewChild('documentUpload', {static: false})
  documentUpload!: NxFileUploaderComponent;

  changeSubscriber!: Subscription;

  uploader!: NxFileUploader;

  fileDataManager: Record<string, Type<UploadDeleteComponent | UploadNameComponent | UploadSizeComponent | UploadStatusComponent>> = {
    uploadDeleteComponent: UploadDeleteComponent,
    uploadNameComponent: UploadNameComponent,
    uploadSizeComponent: UploadSizeComponent,
    uploadStatusComponent: UploadStatusComponent,
  };

  constructor(
    private uploadService: UploadService,
    protected override fieldService: FieldService,
    protected override element: ElementRef,
  ) {
    super(fieldService, element);
  }

  overrideFormGroup(uuid: string, files: any[] = []) {
    files.forEach((el) => {
      el.uuid = uuid;
    });
  }

  onDropped(evt: any) {
    const fileUpload = !this.field.multiple && evt.length > 1 ? evt.slice(0, 1) : evt;
    this.documentUpload._addFilesToQueue(fileUpload);
  }

  uploadElement(res: FileItem[]) {
    this.uploadService.setUploadState(UploadFileStatus.UPLOADING, res.filter((el) => !el.isUploaded) || []);
    if (this.field.name) {
      const test = this.uploadService.uploadFiles(res, this.field).subscribe({
        next: (response: unknown) => {
          const res = response as {data: (FileItem & {uuid?: string})[]; index: number};
          this.formGroup.get(this.field.name)?.updateValueAndValidity();
          //this.uploadService.setUploadState(UploadFileStatus.COMPLETE, this.documentUpload.value || []);
          const {data: addToResponse, index} = res;
          if (addToResponse) {
            const toAdd = Array.isArray(addToResponse) ? addToResponse : [addToResponse];

            const newValues: (FileItem & {uuid?: string})[] = this.documentUpload.value!;
            newValues[index] = toAdd[index];
            this.uploadService.setUploadState(UploadFileStatus.COMPLETE, newValues, index);

            this.formGroup.get(this.field.name)?.patchValue(newValues, {emitEvent: false});
          }
        },
        error: (err: {error: HttpErrorResponse; fileAtIndex?: number}) => {
          console.warn('upload error', err, test.closed);
          this.documentUpload.removeFile(res);

          this.formGroup.get(this.field.name)?.setErrors({genericUploadError: true});
        },
      });
    }
  }

  onDeleteFile(evt: FileItem & {uuid?: string}) {
    const list = this.formGroup.get(this.field.name)?.value.filter((el: FileItem & {uuid: string}) => {
      return el.uuid !== evt['uuid'];
    });

    this.formGroup.get(this.field.name)?.patchValue(list, {emitEvent: false});

    this.uploadService.deleteFile(evt, this.field).subscribe((res) => {});
  }

  onSelectedFile(evt: FileItem[]) {
    this.uploadElement(evt);
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.changeSubscriber?.unsubscribe();
  }
}
